import type { ReactNode } from 'react';

import css from './styles.module.css';

export function MenuDivider(): ReactNode {
	return <hr className={css.menuDivider} />;
}
